module.exports = __webpack_public_path__ + "static/computer-edd2b1a1f370d61357905a8bd5fbe3a0.jpg";